"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncentiveType = exports.Cludes = void 0;
var Cludes;
(function (Cludes) {
    Cludes["includes"] = "Includes";
    Cludes["excludes"] = "Excludes";
})(Cludes = exports.Cludes || (exports.Cludes = {}));
var IncentiveType;
(function (IncentiveType) {
    IncentiveType["customerCash"] = "CustomerCash";
    IncentiveType["dealerCash"] = "DealerCash";
})(IncentiveType = exports.IncentiveType || (exports.IncentiveType = {}));
